import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { computed } from 'mobx-angular';
import { formatForApi } from 'netsocial-lib/src/app/utils/date-utils';
import { ErrorService } from 'netsocial-posting/src/app/services/error/error.service';
import { UserService } from 'netsocial-posting/src/app/services/user/user.service';
import { ChangeFiltersOutput } from '../../components/analytics/analytics-header/analytics-header.component';
import { ExportDialogComponent } from '../../components/analytics/export-dialog/export-dialog.component';
import {
  Export,
  GetStatsExportParams,
  ReportingService,
} from '../../services/reporting/reporting.service';

@Component({
  selector: 'app-analyze',
  templateUrl: './analyze.page.html',
  styleUrls: ['./analyze.page.scss'],
})
export class AnalyzePage {
  @computed
  get isAdmin(): boolean | undefined {
    return this.userService.currentUser?.isAdmin;
  }

  start: ChangeFiltersOutput['start'];
  end: ChangeFiltersOutput['end'];
  filterBy: ChangeFiltersOutput['filterBy'];
  socials: ChangeFiltersOutput['socials'];
  compareResults: ChangeFiltersOutput['compareResults'];
  startCompare: ChangeFiltersOutput['startCompare'];
  endCompare: ChangeFiltersOutput['endCompare'];

  comparison: ChangeFiltersOutput['comparison'];

  exportOption: GetStatsExportParams['format'] = 'email';

  exportPromise: Promise<Export | undefined>;

  constructor(
    private readonly userService: UserService,
    private readonly reportingService: ReportingService,
    private readonly modal: ModalController,
    private readonly errorService: ErrorService
  ) {}

  filtersChanged(filters: ChangeFiltersOutput): void {
    this.start = filters.start;
    this.end = filters.end;
    this.filterBy = filters.filterBy;
    this.socials = filters.socials;
    this.compareResults = filters.compareResults;
    this.startCompare = filters.startCompare;
    this.endCompare = filters.endCompare;
    this.comparison = filters.comparison;
  }

  async quickExport(): Promise<void> {
    const params: GetStatsExportParams = {
      startDate: formatForApi(this.start),
      endDate: formatForApi(this.end),
      format: this.exportOption,
      accountService: this.socials,
    };

    if (this.compareResults) {
      params.compare = 1;
      params.compareMethod = 'custom';
      params.compareStartDate = formatForApi(this.startCompare!);
      params.compareEndDate = formatForApi(this.endCompare!);
    }

    const promise = this.errorService.resolve(this.reportingService.getStatsExport(params), {
      successCallback: () => {
        if (this.exportOption === 'email') {
          this.errorService.toastSuccess('emailSentText');
        }
      },
    });

    this.exportPromise = promise;
    await promise;
  }

  async customExport(): Promise<void> {
    const modal = await this.modal.create({
      component: ExportDialogComponent,
      componentProps: {
        startDate: this.start,
        endDate: this.end,
        startDateCompare: this.startCompare,
        endDateCompare: this.endCompare,
        compareResults: this.compareResults,
        filterBy: this.filterBy,
        socials: this.socials,
        comparison: this.comparison,
      },
    });

    return modal.present();
  }
}
